
















import { defineComponent, ref, toRefs, PropType } from '@vue/composition-api';
import { trackEvent } from './../../../../utils/index';

const name = 'ttam-product-details-filter';
export default defineComponent({
  name,
  components: {},
  props: {
    filterValue: {
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const onSelectChange = value => {
      emit('change', value);
    };

    const handleClickFilter = trackVal => {
      trackEvent(trackVal);
    };

    return {
      name,
      onSelectChange,
      handleClickFilter,
    };
  },
});
